/**
 * «Прочитано»: POST update_last_seen + мгновенное обнуление счётчика в списках.
 * Чаще раза в 1,5 с по одной переписке не шлём — при потоке сообщений иначе был бы шквал запросов.
 */
import type { QueryClient } from '@tanstack/react-query';
import { markConversationRead } from '@/api/inbox';
import { cwKeys, patchAllLists } from './cwCache';

const THROTTLE_MS = 1500;
const lastSent = new Map<string, number>();

export function markRead(
  qc: QueryClient,
  accountId: number,
  convId: number,
  myUserId: number | null,
  now: () => number = Date.now,
): void {
  const key = `${accountId}:${convId}`;
  const t = now();
  const prev = lastSent.get(key) ?? 0;
  if (t - prev < THROTTLE_MS) return;
  lastSent.set(key, t);

  patchAllLists(qc, accountId, { kind: 'read', convId }, myUserId);
  markConversationRead(accountId, convId)
    .then(() => { void qc.invalidateQueries({ queryKey: cwKeys.unread(accountId) }); })
    .catch(() => {
      // Не отметилось (сеть) — разрешим повтор сразу.
      lastSent.delete(key);
    });
}

/** Для проверок. */
export function resetReadMarker(): void {
  lastSent.clear();
}
